import { defineStore } from "pinia";
import { filterByFields, sortedByFields } from '@/entities/Mailing/config/mailing';
import axios from "axios";
import Vue from 'vue'

const brand = {
        fieldsName: 'brand',
        description: 'Бренд',
        id: 'sorted_brand',
        order: 5,
        city: null,
    };

export const useMailingStore = defineStore('MailingStore', {
    state: () => {
        return {
            mailingPeriods: [],
            isActive: true,
            emails: [],
            mailingName: '',
            id: null,
            inSettings: false,
            selectedFormats: 'xml',
            selectedStorageCities: ['voronezh', 'crimea', 'stavropol', 'krasnodar'],
            selectedProducts: ['tyres'],
            sortOrder: 'asc',
            filterByFields: filterByFields,
            sortedByFields: sortedByFields,
            filteredFilterByFields: [],
            checked: {
                field: [
                    {
                        fieldsName: 'name',
                        description: 'Наименование',
                        id: 'field_name',
                        order: 1,
                        city: null,
                    },
                ],
                sortedField: [
                    {
                        fieldsName: 'diameter',
                        description: 'Диаметр',
                        id: 'sorted_diameter',
                        order: 4,
                    },
                ],
            },
            currentInputEmail: '',
        }
    },
    getters: {
        getFilteredFilterByFields(state) {
            // Чтобы не сломать совместимость
            // Обработка созданных до правок рассылок
            if (this.filterByFields.length <= 8) {
                this.filterByFields = [...filterByFields];
                state.filteredFilterByFields = [...filterByFields];
                return state.filteredFilterByFields;
            }
            // Для новых рассылок
            state.filteredFilterByFields = [...this.filterByFields]
            return state.filteredFilterByFields;
        },
    },
    actions:{
        addMailingPeriods(newPeriod) {
            this.mailingPeriods.push(newPeriod);
        },
        changeMailingPeriod(periodData) {
            this.mailingPeriods = this.mailingPeriods.map((period) => periodData.id === period.id ? periodData : period)
        },
        removeMailingPeriod(id) {
            this.mailingPeriods = this.mailingPeriods.filter((item) => item.id !== id);
        },
        toggleIsActive() {
            this.isActive = !this.isActive;
        },
        addEmail(email) {
            this.emails.push(email);
        },
        setIsSettings(bool) {
            this.inSettings = bool;
        },
        changeSortOrder(order) {
            this.sortOrder = order
        },
        resetDataForm() {
            this.isActive = true;
            this.mailingName = '';
            this.emails = [];
            this.mailingPeriods = [];
            this.id = null;
            this.checked.field = [
                {
                    fieldsName: 'name',
                    description: 'Наименование',
                    id: 'field_name',
                    order: 1,
                    city: null,
                },
            ];
            this.checked.sortedField = [
                {
                    fieldsName: 'diameter',
                    description: 'Диаметр',
                    id: 'sorted_diameter',
                    order: 4,
                },
            ];
            this.selectedFormats = 'xml';
            this.selectedStorageCities = ['voronezh', 'crimea', 'stavropol', 'krasnodar'];
            this.selectedProducts = ['tyres'];
            this.sortOrder = 'asc';
            this.filterByFields = filterByFields;
            this.sortedByFields = sortedByFields;
            this.currentInputEmail = '';
        },
        editMailing(id) {

            axios.get(`/api/b2b_user/subscribe/${id}`)
                .then((response) => {
                    const resp = response.data;
                    if (typeof (resp.success) !== "undefined" && (resp.success === true)) {
                        const currentMailing = resp.item;
                        this.mailingName = currentMailing.mailingName;
                        this.isActive = currentMailing.isActive;
                        this.id = currentMailing.id;
                        this.emails = currentMailing.emails;
                        this.mailingPeriods = currentMailing.mailingPeriods;
                        this.selectedFormats = currentMailing.selectedFormats;
                        this.selectedStorageCities = currentMailing.selectedStorageCities;
                        this.selectedProducts = currentMailing.selectedProducts;
                        this.sortOrder = currentMailing.sortOrder;
                        this.filterByFields = currentMailing.filterByFields.length <= 9 ? [...currentMailing.filterByFields, brand] : currentMailing.filterByFields;
                        this.sortedByFields = currentMailing.sortedByFields;
                        this.checked.field = currentMailing.selectedByField;
                        this.checked.sortedField = currentMailing.selectedBySortedField;
                        this.setIsSettings(true);
                    }
                    if (typeof (resp.error) !== "undefined" && (resp.error === true)) {
                        this.$notifyError(resp.message);
                    }


                })
                .catch((error) => {
                    console.log(error);
                    this.$notifyError('Неизвестная ошибка, попробуйте вновь или обратитесь к менеджеру');
                });
        },
        addedEmail() {
                const email = String(this.currentInputEmail).toLowerCase();
                if (!this.validateEmail(email)) {
                    return true;
                };

                if (this.emails.includes(email)) {
                    return true;
                }

                this.currentInputEmail = '';
                this.addEmail(email);
                return false;
        },
        validateEmail(email) {
            const expression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return expression.test(email);
        },
    },
});
